// extracted by mini-css-extract-plugin
export default {"combo-box-block-root":"ComboBoxBlock_combo-box-block-root__yOIQb","block":"ComboBoxBlock_block__Oyawf","label":"ComboBoxBlock_label__9z4Mx"};